export const crapienv: {
    IDENTITY_SERVICE: string;
    WORKSHOP_SERVICE: string;
    COMMUNITY_SERVICE: string;
    TRACEABLE_CAPTCHA_SITE_KEY: string;
    TRACEABLE_CAPTCHA_URL: string;
    TRACEABLE_CAPTCHA_TOKEN_CALLBACK_ENABLED: string;
} = {
    IDENTITY_SERVICE: "identity/",
    WORKSHOP_SERVICE: "workshop/",
    COMMUNITY_SERVICE: "community/",
    TRACEABLE_CAPTCHA_SITE_KEY: "{{TRACEABLE_CAPTCHA_SITE_KEY}}",
    TRACEABLE_CAPTCHA_URL: "{{TRACEABLE_CAPTCHA_URL}}",
    TRACEABLE_CAPTCHA_TOKEN_CALLBACK_ENABLED: "{{TRACEABLE_CAPTCHA_TOKEN_CALLBACK_ENABLED}}",
};
